import { FC, FormEventHandler, useState } from 'react'
import { Form } from 'react-router';
import type { FormProps } from 'react-router';
import { SelectButton } from '~/components/buttons'
import {
  CartItemModel,
  ProductModel,
  ProductModelJSON,
} from '~/models'
import { addItem } from '~/utils/cart.client'

type Props = {
  stockInput: string
  product: ProductModelJSON
  formProps?: FormProps
}

export const CartForm: FC<Props> = ({
  product,
  stockInput,
  formProps,
}) => {
  const [quantity, setQuantity] = useState<string>('1')
  const onSubmit: FormEventHandler<HTMLFormElement> = event => {
    event.preventDefault()
    window.confirm('カートに追加しました')
    const productModel = ProductModel.fromJSON(product)
    const item = new CartItemModel({
      quantity: Number(quantity),
      product: productModel,
    })
    addItem(item)
  }

  return (
    <Form onSubmit={onSubmit} {...formProps}>
      <div className="flex my-2">
        <label htmlFor={stockInput}>数量</label>
        <select
          id={stockInput}
          name={stockInput}
          className="ml-4 w-16 border"
          value={quantity}
          onChange={event => setQuantity(event.target.value)}
        >
          {[...Array(product.stock).keys()].map(i => (
            <option key={i} value={i + 1}>{i + 1}</option>
          ))}
        </select>
      </div>
      <div className="flex justify-center">
        <SelectButton type="submit" className="">カートに入れる</SelectButton>
      </div>
    </Form>
  )
}
